// SJT Customer Service — Scoring Engine
// Format: Most Effective (2pts) + Least Effective (1pt) per item = max 60 pts
import { SJT_CUSTOMER_ITEMS } from "./questionBank.js";

export const SJT_CS_NORMS = {
  overall: { mean:41.2, sd:7.8, n:850 },
  by_sector: {
    bpo:          { mean:43.1, sd:7.2 },
    banking:      { mean:42.4, sd:7.6 },
    retail:       { mean:40.3, sd:8.1 },
    hospitality:  { mean:44.2, sd:6.9 },
    general:      { mean:41.2, sd:7.8 },
  }
};

export const SJT_CS_BANDS = [
  { min:0,  max:20, label:"Developing",  color:"#dc2626", hire:"Not recommended for customer-facing roles without significant coaching." },
  { min:20, max:40, label:"Average",     color:"#d97706", hire:"Meets minimum threshold. Suitable with structured onboarding and coaching." },
  { min:40, max:70, label:"Strong",      color:"#1d4ed8", hire:"Recommended. Demonstrates sound customer service judgement in most scenarios." },
  { min:70, max:100,label:"Exceptional", color:"#059669", hire:"Strongly recommended. Consistent excellence in service judgement and de-escalation." },
];

export const SJT_CS_DIMENSIONS = [
  { id:"de_escalation",     label:"De-escalation & Empathy",    items:[0,5,10,18], icon:"🤝" },
  { id:"process_adherence", label:"Policy & Process Adherence", items:[2,9,15,16], icon:"📋" },
  { id:"ownership",         label:"Ownership & Accountability", items:[7,13,17,19], icon:"⚡" },
  { id:"communication",     label:"Clear Communication",         items:[3,8,12,14], icon:"💬" },
  { id:"problem_solving",   label:"Problem Resolution",          items:[1,4,6,11],  icon:"🎯" },
];

export function scoreSJT_CS(mostAnswers, leastAnswers) {
  // mostAnswers[i] = index of selected Most Effective (0-3)
  // leastAnswers[i] = index of selected Least Effective (0-3)
  let totalScore = 0;
  const itemScores = [];

  SJT_CUSTOMER_ITEMS.forEach((item, i) => {
    let itemScore = 0;
    if (mostAnswers[i] === item.most)   itemScore += 2;
    if (leastAnswers[i] === item.least) itemScore += 1;
    totalScore += itemScore;
    itemScores.push(itemScore);
  });

  const maxScore = SJT_CUSTOMER_ITEMS.length * 3; // 20 * 3 = 60
  const rawPct   = Math.round((totalScore / maxScore) * 100);

  const norm = SJT_CS_NORMS.overall;
  const z    = (totalScore - norm.mean) / norm.sd;
  const percentile = Math.min(99, Math.max(1, Math.round(50 + z * 17)));
  const band = SJT_CS_BANDS.find(b => percentile >= b.min && percentile < b.max) || SJT_CS_BANDS[0];

  // Dimension scores
  const dimScores = {};
  SJT_CS_DIMENSIONS.forEach(dim => {
    const dimTotal = dim.items.reduce((sum, idx) => sum + (itemScores[idx] || 0), 0);
    const dimMax   = dim.items.length * 3;
    dimScores[dim.id] = {
      score: dimTotal, max: dimMax,
      pct: Math.round((dimTotal / dimMax) * 100),
      label: dim.label, icon: dim.icon
    };
  });

  return {
    totalScore, maxScore, rawPct, percentile, band,
    itemScores, dimScores,
    scales: { sjt_customer: percentile },
  };
}
